module.exports = {

  // // production
  // apiEndpoint: "https://api.bharatselfdrive.com/api/v1",
  // apiEndpoint: "https://api.bharatselfdrive.com/api/v2",
  // authApiEndpoint: "https://api.bharatselfdrive.com/api/v1",
  // BaseUrl: "https://api.bharatselfdrive.com",

  // // // staging
  // apiEndpoint: "https://testingapi.bharatselfdrive.com/api/v1",
  apiEndpoint: "https://testingapi.bharatselfdrive.com/api/v2",
  /** Login / logout / token refresh — staging v2 auth routes return 401 without Bearer; v1 accepts credential POSTs. */
  authApiEndpoint: "https://testingapi.bharatselfdrive.com/api/v1",
  BaseUrl: "https://testingapi.bharatselfdrive.com",


  // development - use proxy path to avoid CORS
  // BaseUrl: "http://localhost:4000",
  // apiEndpoint: "http://localhost:4000/api/v2",
  // authApiEndpoint: "http://localhost:4000/api/v1",
  // authApiEndpoint: "http://localhost:4000/api/v2",
  //  BaseUrl: "http://localhost:4000",

  GOOGLE_PLACES_API_KEY: "AIzaSyBoCgpI2He8LNoG8hL1PHLUsUCK96AhKqQ",
  GOOGLE_MAPS_API_KEY: "AIzaSyA9f1886nyARbq6RRT47aFIXAIIINtWmXI",
  // Backward compatibility for existing code paths.
  GOOGLE_MAP_KEY: "AIzaSyA9f1886nyARbq6RRT47aFIXAIIINtWmXI",
  MAP_AUTO_REFESH: 45,
  referralEndpoint: "https://referral.bharatselfdrive.com/api/v1",

  // RC document type IDs (must match backend .env DOC_RC_DOCTYPE_FRONT / DOC_RC_DOCTYPE_BACK)
  DOC_RC_DOCTYPE_FRONT: 1,
  DOC_RC_DOCTYPE_BACK: 32,
};
